/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Avatar_PlaceholderInputs */

const en_profile_avatar_placeholder = /** @type {(inputs: Profile_Avatar_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://example.com/avatar.jpg`)
};

const pt_br2_profile_avatar_placeholder = /** @type {(inputs: Profile_Avatar_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://exemplo.com/avatar.jpg`)
};

/**
* | output |
* | --- |
* | "https://example.com/avatar.jpg" |
*
* @param {Profile_Avatar_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_avatar_placeholder = /** @type {((inputs?: Profile_Avatar_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Avatar_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_avatar_placeholder(inputs)
	return pt_br2_profile_avatar_placeholder(inputs)
});